/*
  <sticky-cart> — shows a fixed add-to-cart on scroll. On desktop it's a full
  bar (thumbnail, title, price, variant select, Add). On mobile it collapses to
  a single floating Add to cart button. The Add button is a Dawn <product-form>,
  so it adds via AJAX and updates the cart drawer. The sticky variant is kept in
  sync with the main product form so the mobile button always adds the selected
  variant. Visibility is driven by IntersectionObserver on the main ATC.
*/
if (!customElements.get('sticky-cart')) {
  customElements.define(
    'sticky-cart',
    class StickyCart extends HTMLElement {
      connectedCallback() {
        this.target = document.querySelector(this.dataset.observe);
        this.select = this.querySelector('[data-sticky-variants]');
        this.priceEl = this.querySelector('[data-sticky-price]');
        this.idInput = this.querySelector('[name="id"]');

        if (this.select) {
          this.select.addEventListener('change', this.onVariantChange.bind(this));
        }

        if (this.target && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(this.onIntersect.bind(this), { threshold: 0 });
          this.observer.observe(this.target);
        }

        // Keep the sticky variant in sync with the main product form so the
        // mobile floating Add button adds the customer's selected variant.
        this.onMainChange = (event) => {
          if (event.target.closest('variant-selects') && !event.target.closest('sticky-cart')) {
            setTimeout(() => this.syncWithMainForm(), 80);
          }
        };
        document.addEventListener('change', this.onMainChange);
        this.syncWithMainForm();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        document.removeEventListener('change', this.onMainChange);
      }

      onIntersect(entries) {
        const entry = entries[0];
        // Reveal once the main add-to-cart has scrolled out of view.
        const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.classList.toggle('is-visible', scrolledPast);
      }

      onVariantChange() {
        if (!this.select) return;
        const option = this.select.options[this.select.selectedIndex];
        if (this.priceEl && option && option.dataset.price) {
          this.priceEl.textContent = option.dataset.price;
        }
      }

      syncWithMainForm() {
        const mainInput = document.querySelector('product-info [name="id"]');
        if (!mainInput || !mainInput.value || !this.idInput) return;
        this.idInput.value = mainInput.value;
        if (this.select) {
          this.select.value = mainInput.value;
          this.onVariantChange();
        }
      }
    }
  );
}
